// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCallistoError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M24 2H0V18H11.5383C11.6104 17.2989 11.7823 16.6274 12.0397 16H2V4H22V12.2675C22.7505 12.6445 23.4265 13.148 24 13.75V2ZM11.6074 20C11.7302 20.7071 11.9556 21.3791 12.2675 22H7L8 20H11.6074Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.75 32C29.6495 32 32 29.6495 32 26.75C32 23.8505 29.6495 21.5 26.75 21.5C23.8505 21.5 21.5 23.8505 21.5 26.75C21.5 29.6495 23.8505 32 26.75 32ZM24.875 23.75L23.75 24.875L25.625 26.75L23.75 28.625L24.875 29.75L26.75 27.875L28.625 29.75L29.75 28.625L27.875 26.75L29.75 24.875L28.625 23.75L26.75 25.625L24.875 23.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.875 23.75L23.75 24.875L25.625 26.75L23.75 28.625L24.875 29.75L26.75 27.875L28.625 29.75L29.75 28.625L27.875 26.75L29.75 24.875L28.625 23.75L26.75 25.625L24.875 23.75Z" class="svg-fg"/>
  <path d="M32 3H0V25H19.7126C19.8897 24.2856 20.1727 23.6131 20.5439 23H2.00044V4.99996H30.0004V20.2677C30.7508 20.6447 31.4266 21.1481 32 21.75V3ZM19.5042 27C19.5278 27.696 19.6495 28.3671 19.8559 29H9L10 27H19.5042Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedCallistoError is a generated icon component.
 */
let IconMedCallistoError = IconMedCallistoError_1 = class IconMedCallistoError extends IconBaseElement {
    render() {
        return html `${IconMedCallistoError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCallistoError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedCallistoError = IconMedCallistoError_1 = __decorate([
    customElement('zui-icon-med-callisto-error')
], IconMedCallistoError);
export { IconMedCallistoError };
